import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import BrandsSchemasHelmet from './BrandsSchemasHelmet'
import { getDescription, getTitle, getCanonicalUrl } from 'components/Head/helpers'


export const mapStateToProps = ({ app: { data }}) => {
  let currentUrl = ''

  if (window && window.location) {
    currentUrl = window.location.href
  }

  return {
    canonicalUrl: data.canonical ? getCanonicalUrl(data) : currentUrl,
    description: data ? getDescription(data) : '',
    title: data ? getTitle(data) : ''
  }
}

const withBrandsSchema = withProps(({ canonicalUrl, description, title }) => {
  const brandsSchema = {
    '@context': 'http://schema.org',
    '@type': ['Webpage'],
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': canonicalUrl
    },
    url: canonicalUrl,
    speakable: {
      '@type': 'SpeakableSpecification',
      cssSelector: ['h1', '.speakable-summary']
    },
    significantLink: 'https://www.bigotires.com/appointment/quick-appointment',
    isPartOf: {
      '@type': 'Webpage',
      name: 'Big O Tires Auto Repair Services',
      '@id': 'https://www.bigotires.com/services/'
    },
    name: title,
    description,
    provider: 'Big O Tires',
    potentialAction: 'http://schema.org/ScheduleAction',
    audience: {
      '@type': 'PeopleAudience',
      name: 'Car Owners'
    },
    mentions: [
      {
        '@type': 'WebPage',
        name: 'Schedule Tire Installation',
        url: 'https://www.bigotires.com/appointment/quick-appointment',
        '@id': 'https://www.bigotires.com/appointment/quick-appointment'
      }, {
        '@type': 'WebPage',
        name: 'Shop for New Tires',
        url: 'https://www.bigotires.com/tires/',
        '@id': 'https://www.bigotires.com/tires/'
      }, {
        '@type': 'WebPage',
        name: 'Auto Repair Services',
        url: 'https://www.bigotires.com/services/',
        '@id': 'https://www.bigotires.com/services/'
      }, {
        '@type': 'WebPage',
        name: 'Local Deals and Specials',
        url: 'https://www.bigotires.com/deals',
        '@id': 'https://www.bigotires.com/deals'
      }]
  }

  return {
    brandsSchema: JSON.stringify(brandsSchema)
  }
})

export default compose(
  connect(mapStateToProps),
  withBrandsSchema
)(BrandsSchemasHelmet)
